import { render, staticRenderFns } from "./discountTypeList.vue?vue&type=template&id=39e09308&scoped=true"
import script from "./discountTypeList.vue?vue&type=script&lang=js"
export * from "./discountTypeList.vue?vue&type=script&lang=js"
import style0 from "./discountTypeList.vue?vue&type=style&index=0&id=39e09308&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_a6c7c6c484daeff6636bea47b922569f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39e09308",
  null
  
)

export default component.exports